import { LogEvents } from "../../../utils/LogEvents";
import { SSO_LOGIN_URL } from "../../../AppConstants";
import { RetryServiceCallUntilSuccessOrTimeout } from "../../Utils";
import { ErrorStringFromException } from "../../../utils/utils";

declare const OfficeFirstPartyAuth: any;

// This class contains shared implementations for PpeAuthenticationProvider and ProdAuthenticationProvider
export class AuthSharedComponent {
    private officeFirstPartyAuthLoaded: boolean = false;
    private authenticationTask: Promise<void> = null;

    Authenticate(): void {
        LogEvents.ServiceAuthentication.Start();
        if (this.officeFirstPartyAuthLoaded) {
            LogEvents.ServiceAuthentication.AddResponse({ isSuccessful: true, message: "Success", isFinalResponse: true });
            return;
        }

        this.authenticationTask = RetryServiceCallUntilSuccessOrTimeout(
            LogEvents.ServiceAuthentication /*logServiceEvent*/, 
            () => OfficeFirstPartyAuth.load(SSO_LOGIN_URL) /*throwingServiceCall*/, 
            false /*shouldRetryOnNull*/
        ).then(() => {
            this.officeFirstPartyAuthLoaded = true;
        });
    }

    async GetAccessToken(resource: string): Promise<string> {
        LogEvents.ServiceGetAccessToken.Start();
        if (!this.officeFirstPartyAuthLoaded) {
            if (this.authenticationTask == null) {
                const message: string = "GetAccessToken: Call Authenticate before calling GetAccessToken!";
                LogEvents.ServiceGetAccessToken.AddResponse({ isSuccessful: false, message, isFinalResponse: true});
                throw new Error(message);
            } else {
                try {
                    await this.authenticationTask;
                } catch (error) {
                    LogEvents.ServiceGetAccessToken.AddResponse({ isSuccessful: false, message: "GetAccessToken: Authenticate failed with error: " + ErrorStringFromException(error), isFinalResponse: true});
                    throw error;
                }
            }
        }

        let popupRequired: boolean = false;
        let token: any = await RetryServiceCallUntilSuccessOrTimeout(
            LogEvents.ServiceGetAccessToken /*logServiceEvent*/, 
            () => {
                const token: any = OfficeFirstPartyAuth.getAccessToken({ "resource": resource }, popupRequired ? { "popup": true } : undefined) /*throwingServiceCall*/
                popupRequired = true;
                return token;
            } /*throwingServiceCall*/,
            true /*shouldRetryOnNull*/,
            (e) => e.code != 'popup_window_error' /*shouldRetryError*/,
            () => popupRequired /*shouldIgnoreTimeout*/
        );

        return token.accessToken;
      }
}
